'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Headline = require('../../01.atoms/Headline/Headline.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-teaser-article',
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnContentWrapper = "".concat(CLASSNAME, "__content-wrapper"),
    cnContent = "".concat(CLASSNAME, "__content"),
    cnReadingTime = "".concat(CLASSNAME, "__reading-time"),
    cnReadingTimeIcon = "".concat(cnReadingTime, "__icon"),
    cnImage = "".concat(CLASSNAME, "__image");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function TeaserArticle(_ref) {
  var className = _ref.className,
      content = _ref.content,
      headlineLevel = _ref.headlineLevel,
      headline = _ref.headline,
      iconId = _ref.iconId,
      link = _ref.link,
      readingTime = _ref.readingTime,
      srcset = _ref.srcset,
      timeUnit = _ref.timeUnit;
  return /*#__PURE__*/React__default.createElement(Link, {
    link: link,
    className: classNames(CLASSNAME, className)
  }, srcset && /*#__PURE__*/React__default.createElement("div", {
    className: cnImage,
    style: {
      backgroundImage: "url(".concat(srcset.lg || srcset.md || srcset.xs, ")"),
      backgroundSize: 'cover',
      backgroundPosition: 'center center'
    }
  }), readingTime && /*#__PURE__*/React__default.createElement("div", {
    className: cnReadingTime
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "time",
    size: "xxs",
    className: cnReadingTimeIcon
  }), readingTime, " ", timeUnit), /*#__PURE__*/React__default.createElement("div", {
    className: cnContentWrapper
  }, /*#__PURE__*/React__default.createElement(Headline, {
    className: cnTitle,
    level: headlineLevel
  }, headline), content && /*#__PURE__*/React__default.createElement("p", {
    className: cnContent
  }, content), link && /*#__PURE__*/React__default.createElement(Icon, {
    className: cnIcon,
    id: iconId,
    size: "sm"
  })));
}
TeaserArticle.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Article content */
  content: PropTypes.string,

  /** Level of headline e.g. 1 for h1 */
  headlineLevel: PropTypes.number,

  /** Title string */
  headline: PropTypes.string,

  /** Id of icon */
  iconId: PropTypes.string,

  /** URL string to link to */
  link: PropTypes.string,

  /** Time to read */
  readingTime: PropTypes.number,

  /** Teaser image set */
  srcset: PropTypes.object,

  /** Unit of reading time */
  timeUnit: PropTypes.string
};
TeaserArticle.defaultProps = {
  headlineLevel: 3,
  iconId: 'arrow-right',
  timeUnit: 'min'
};

module.exports = TeaserArticle;
